
import { Button, Container } from "react-bootstrap";
import "../ASSETS/css/main.css";

import logo from "../ASSETS/images/logo-starken.png";

export default function DominioInCorrecto(props: any) {

  return (
    <Container className="containerPrincipal shadow rounded" style={{ background: "white" }}>
      <Container className="containerSecundario">
        <Container style={{ marginBottom: 20 }}>
          <img alt="banner" src={logo} />
        </Container>

        <hr style={{ color: "green" }} />

        <Container style={{ marginBottom: 20 }}>
          <h3>No se puede ingresar desde este dominio. </h3>
          <h4>Por favor, inicia sesión en TOPdesk. </h4>
          <hr style={{ color: "green" }} />
          <Button className="btn btn-success" href="https://starken.topdesk.net/"> TOPdesk </Button>
        </Container>
      </Container>
    </Container>
  );
}
